import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendRequest,
  requestInProcess,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  initState
} from '../../../../common/reducers/execDisputeForm';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/TasksExecsService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { deleteGroupItems } from '../../../../../../common/reducers/listsCollection/reducer';
import { dataRequest } from '../../../../../../common/reducers/objectCollection/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* execDisputeSaga(reducerName, action) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(
      timeoutCall,
      TasksExecsService.createDispute,
      action.payload,
      formBody
    );
    if (result) {
      if (result.status === 422) {
        yield put(setErrors(reducerName, result.data));
      } else if (result.status === 200) {
        yield put(initState(reducerName));
        yield put(sendGetAuthAccountDataRequest());
        yield put(
          deleteGroupItems(
            'tasksModule.collections.tasksExecsNotSendMaterialsCollection',
            action.payload
          )
        );
        yield put(
          dataRequest(
            'tasksModule.collections.tasksExecsCollection',
            action.payload
          )
        );
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: result.data.message
          })
        );
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, execDisputeSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/saga/execDisputeSaga.js